import {
  ApiErrorSchema,
  PublicContentResponseSchema,
  SpecializationListResponseSchema,
  type Locale,
  type PublicContentResponse,
  type SpecializationListResponse,
} from '@ah/contracts';

/**
 * Thin fetch wrapper for the public CMS endpoints — published landing copy
 * and the active specialization list. No auth: this is the marketing
 * surface anyone can see before registering.
 */
export class ContentApi {
  constructor(private readonly baseUrl: string) {}

  async getContent(namespace: string, locale: Locale): Promise<PublicContentResponse> {
    const res = await fetch(`${this.baseUrl}/api/v1/content/${encodeURIComponent(namespace)}?locale=${locale}`);
    if (!res.ok) throw await this.toError(res);
    return PublicContentResponseSchema.parse(await res.json());
  }

  async listSpecializations(): Promise<SpecializationListResponse> {
    const res = await fetch(`${this.baseUrl}/api/v1/specializations`);
    if (!res.ok) throw await this.toError(res);
    return SpecializationListResponseSchema.parse(await res.json());
  }

  private async toError(res: Response): Promise<Error> {
    try {
      const payload = ApiErrorSchema.parse(await res.json());
      return new ContentApiError(payload.error.code, payload.error.message, res.status);
    } catch {
      return new ContentApiError('INTERNAL_ERROR', res.statusText, res.status);
    }
  }
}

export class ContentApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ContentApiError';
  }
}
